import * as React from 'react';
const SvgChevronDown = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="nonzero">
         <path d="M27.29 32.524a1.66 1.66 0 0 0-.11 2.42 1.85 1.85 0 0 0 2.53.106L42.92 23.476a1.66 1.66 0 0 0 .11-2.42 1.85 1.85 0 0 0-2.532-.106z" />
         <path d="M29.71 32.524c.73.64.78 1.723.11 2.42a1.85 1.85 0 0 1-2.53.106L14.08 23.476a1.66 1.66 0 0 1-.11-2.42 1.85 1.85 0 0 1 2.532-.106z" />
      </g>
   </svg>
);
export default SvgChevronDown;
